export default __webpack_public_path__ + "static/media/star6.c1682fa4.mp3";